<template>
  <div>
    <div>
       <CustomLoader v-if="isLoading" :width="70"></CustomLoader>

      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <!-- <b-navbar-nav>
            <b-button @click="previousSalesView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true"
                >skip_previous</md-icon
              >Back
            </b-button>
          </b-navbar-nav> -->
          <b-navbar-brand center>Supplementary Invoice</b-navbar-brand>
        </b-navbar>

        <b-card class="formCard">
          <b-card-text>
            <div>
              <!-- *******************************  Start  WareHouse  Warehouse Stuffing At ICD *****************************-->
              <div
                class="mt-2"
                v-if="containerTypeDetailFactoryList.length > 0"
              >
                <h5>
                  <b-badge>Container Details</b-badge>
                </h5>
                <div>
                  <b-button
                    v-if="
                      ContainerTypeSizefactory.ffExecutionContainerId != '' &&
                      showMoreSB == false
                    "
                    size="sm"
                    variant="outline-dark"
                    @click="showMoreSBDet"
                    >{{ showMoreSB == true ? "Show" : "Hide " }} Container
                    Details</b-button
                  >
                </div>

                <!-- /.box-header -->

                <b-card
                  class="mt-3"
                  v-if="
                    (getContainerList.length > 0 ||
                      ContainerTypeSizefactory.ffExecutionContainerId != '') &&
                    showMoreSB == false
                  "
                  style="background: whiteSmoke"
                >
                  <div
                    class="gutr"
                    v-if="
                      getContainerList.length > 0 ||
                      ContainerTypeSizefactory.ffExecutionContainerId != ''
                    "
                  >
                    <div v-if="showMoreSB == false">
                      <!-- <md-layout md-gutter>
                          <md-layout md-flex="5"></md-layout>
                          <md-layout md-flex="95">
                            <label>
                              <b>
                                <u>
                                  Container Details
                                  <span
                                    class="error"
                                    v-if="containerTypeDetailFactory.length==0"
                                  >{{errorAtleastContainer}}</span>
                                </u>
                              </b>
                            </label>
                          </md-layout>
                        </md-layout> -->

                      <md-layout md-gutter class="labelMargtop">
                        <md-layout md-flex="50">
                          <label
                            v-if="
                              ContainerTypeSizefactory.ffExecutionContainerId ==
                              ''
                            "
                            >Container Type/Size</label
                          >
                          <model-list-select
                            v-if="
                              ContainerTypeSizefactory.ffExecutionContainerId ==
                              ''
                            "
                            option-value="containerTypeId"
                            option-text="containerType"
                            :list="ContainerTypeList"
                            placeholder="Select  Type/Size"
                            v-model="ContainerTypeSizefactory.containerTypeId"
                          ></model-list-select>
                          <md-layout md-flex="100" v-else>
                            <label for="containerType"
                              >Container Type/Size</label
                            >
                            <b-form-input :formatter="capitalizeAll"
                              v-model="ContainerTypeSizefactory.containerType"
                              disabled
                            ></b-form-input>
                          </md-layout>
                          <span
                            class="error"
                            v-if="!ContainerTypeSizefactory.containerTypeId"
                            >{{ errorContainer.containerTypeId }}</span
                          >
                        </md-layout>

                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="45">
                          <md-layout md-flex="100">
                            <label>Container No.(eg. AAAA1234567)</label>
                            <b-form-input :formatter="capitalizeAll"
                              name="containerNo"
                              v-model="ContainerTypeSizefactory.containerNo"
                              @keyup="containerNoRegexfun"
                            ></b-form-input>
                          </md-layout>
                          <span
                            class="error"
                            v-if="!ContainerTypeSizefactory.containerNo"
                            >{{ errorContainer.containerNo }}</span
                          >
                          <span
                            class="error"
                            v-else-if="containerNoRegexError != ''"
                            >{{ containerNoRegexError }}</span
                          >
                          <span
                            class="error"
                            v-if="
                              containerNoRegexError == '' &&
                              ContainerTypeSizefactory.containerNo != '' &&
                              ContainerTypeSizefactory.containerNo !=
                                algoConNo &&
                              showAlgo == true
                            "
                            >Note:System Generated Container No. is :
                            {{ algoConNo }}</span
                          >
                        </md-layout>
                      </md-layout>
                      <md-layout md-gutter class="labelMargtop">
                        <md-layout md-flex="55"></md-layout>
                        <md-layout md-flex="10">
                          <md-layout md-flex="100">
                            <label>Net Wgt.</label>
                            <b-form-input :formatter="capitalizeAll"
                              id="netWeight"
                              name="netWeight"
                              type="number"
                              min="0"
                              v-model="ContainerTypeSizefactory.netWeight"
                            ></b-form-input>
                          </md-layout>
                        </md-layout>
                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="10">
                          <md-layout md-flex="100">
                            <label>Gross Wgt</label>
                            <b-form-input :formatter="capitalizeAll"
                              id="grossWeight"
                              name="grossWeight"
                              type="number"
                              min="0"
                              v-model="ContainerTypeSizefactory.grossWeight"
                            ></b-form-input>
                          </md-layout>

                          <span
                            class="error"
                            v-if="!ContainerTypeSizefactory.grossWeight"
                            >{{ errorContainer.grossWeight }}</span
                          >
                        </md-layout>

                        <md-layout md-flex="5"></md-layout>

                        <md-layout md-flex="15">
                          <label for="weightUnit">Unit</label>
                          <model-list-select
                            :list="unitList"
                            option-value="uV"
                            option-text="uT"
                            placeholder="Select Unit"
                            name="weightUnit"
                            id="weightUnit"
                            v-model="ContainerTypeSizefactory.weightUnit"
                          ></model-list-select>
                        </md-layout>
                      </md-layout>

                      <md-layout md-gutter class="labelMargtop">
                        <md-layout md-flex="15">
                          <label>Handover Date</label>
                          <date-picker
                          :format="selectDateFormat"
                            lang="en"
                            :minute-step="1"
                            name="handoverDate"
                            id="handoverDate"
                            v-model="ContainerTypeSizefactory.handoverDate"
                          ></date-picker>
                        </md-layout>

                        <md-layout md-flex="5"></md-layout>

                        <md-layout md-flex="25">
                          <md-layout md-flex="100">
                            <label>Custom Seal No.</label>
                            <b-form-input :formatter="capitalizeAll"
                              id="customSealNo"
                              name="customSealNo"
                              v-model="ContainerTypeSizefactory.customSealNo"
                            ></b-form-input>
                          </md-layout>
                        </md-layout>
                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="25">
                          <md-layout md-flex="100">
                            <label>Line Seal No.</label>
                            <b-form-input :formatter="capitalizeAll"
                              id="LineSealNo"
                              name="LineSealNo"
                              v-model="ContainerTypeSizefactory.LineSealNo"
                            ></b-form-input>
                          </md-layout>
                        </md-layout>
                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="20">
                          <md-layout md-flex="100">
                            <label>Container Tare Wgt</label>
                            <b-form-input :formatter="capitalizeAll"
                              id="tareWeight"
                              name="tareWeight"
                              type="number"
                              min="0"
                              v-model="ContainerTypeSizefactory.tareWeight"
                            ></b-form-input>
                          </md-layout>
                        </md-layout>
                      </md-layout>

                      <md-layout md-gutter class="labelMargtop">
                        <md-layout md-flex="20">
                          <md-layout md-flex="100">
                            <label>Measurement (in CBM)</label>
                            <b-form-input :formatter="capitalizeAll"
                              name="noOfpkgUnit"
                              id="noOfpkgUnit"
                              type="number"
                              min="0"
                              v-model="ContainerTypeSizefactory.measurement"
                            ></b-form-input>
                            <!-- <span
                    class="error"
                    v-if="!ContainerTypeSizefactory.measurement"
                              >{{errorContainer.measurement}}</span>-->
                          </md-layout>
                        </md-layout>

                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="20">
                          <label>Package Details</label>
                          <model-list-select
                            :list="packageNameList"
                            id="clientId"
                            v-model="ContainerTypeSizefactory.packageId"
                            option-value="packageId"
                            option-text="packageName"
                            placeholder="Select  Package Name"
                          ></model-list-select>

                          <span
                            class="error"
                            v-if="!ContainerTypeSizefactory.packageId"
                            >{{ errorContainer.packageId }}</span
                          >
                        </md-layout>
                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="50">
                          <md-layout md-flex="100">
                            <label
                              >No. of Packages ({{
                                ContainerTypeSizefactory.packageName
                              }})</label
                            >
                            <b-form-input :formatter="capitalizeAll"
                              name="noOfpkgUnit"
                              id="noOfpkgUnit"
                              type="number"
                              min="0"
                              :disabled="
                                ContainerTypeSizefactory.packageName == ''
                                  ? true
                                  : false
                              "
                              v-model="ContainerTypeSizefactory.noOfpkgUnit"
                            ></b-form-input>
                            <span
                              class="error"
                              v-if="!ContainerTypeSizefactory.noOfpkgUnit"
                              >{{ errorContainer.noOfpkgUnit }}</span
                            >
                          </md-layout>
                        </md-layout>
                      </md-layout>

                      <md-layout md-gutter class="labelMargtop">
                        <md-layout md-flex="20">
                          <label>Cargo Stuffing Date</label>
                          <date-picker
                          :format="selectDateFormat"
                            lang="en"
                            name="cargoStuffingDate"
                            id="cargoStuffingDate"
                            v-model="ContainerTypeSizefactory.cargoStuffingDate"
                            :minute-step="1"
                          ></date-picker>
                        </md-layout>
                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="20">
                          <label>LEEO (Let Export Permit) Date</label>
                          <date-picker
                          :format="selectDateFormat"
                            lang="en"
                            name="leeoDate"
                            id="leeoDate"
                            v-model="ContainerTypeSizefactory.leeoDate"
                            :minute-step="1"
                          ></date-picker>
                        </md-layout>
                        <md-layout md-flex="5"></md-layout>
                        <md-layout md-flex="50">
                          <md-layout md-flex="100">
                            <label>LEEO (Let Export Permit) No.</label>
                            <b-form-input :formatter="capitalizeAll"
                              name="leeoNo"
                              id="leeoNo"
                              v-model="ContainerTypeSizefactory.leeoNo"
                            ></b-form-input>
                          </md-layout>
                        </md-layout>
                      </md-layout>
                    </div>
                  </div>
                </b-card>

                <div class="box-body mt-2">
                  <table id="ffContainer" class="table table-bordered">
                    <thead>
                      <tr>
                        <th>Sr No.</th>

                        <th>Container No.</th>

                        <th>Container Type</th>
                        <th>Custom Seal No.</th>
                        <th>Line Seal No.</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, index) in containerTypeDetailFactoryList"
                        :key="index"
                      >
                        <td>{{ index + 1 }}</td>
                        <td
                          @click="viewEdit(item.ffExecutionContainerId, index)"
                          class="showMoreData"
                        >
                          {{ item.containerNo }}
                        </td>
                        <td
                          @click="viewEdit(item.ffExecutionContainerId, index)"
                          class="showMoreData"
                        >
                          {{ item.containerType }}
                        </td>

                        <td>
                          {{
                            item.customSealNo != "" ? item.customSealNo : "--"
                          }}
                        </td>
                        <td>
                          {{ item.LineSealNo != "" ? item.LineSealNo : "--" }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <!-- /.box-body -->
              </div>
<!-- <div class="mt-4" v-if="(SBDetail.supffSlinePayId!='' && accounts==false) || (SBDetail.supffSlinePayId!='' && role=='Admin') "> <b-form-checkbox

      id="checkbox-1"
      v-model="SBDetail.revisedMail"
      name="checkbox-1"
      value="1"
      unchecked-value="0"
    >
      
    </b-form-checkbox><span class="error">Send Revised Payment Request</span></div> -->
              <md-layout gutter class="gutr">
                <!-- <md-layout md-flex="45">
                  <md-input-container>
                    <label>B/L Draft By Shipping Line</label>
                    <md-file
:disabled="accounts == true && role!='Admin'?true:false"
                      name="invoiceUpload"
                      id="invoiceUpload"
                      v-model="SBDetail.blDraftUpload"
                      @selected="onFileChangeBlDraft('BL_DRAFT')"
                      multiple
                    ></md-file>
                  </md-input-container>
                </md-layout>
                <md-layout md-flex="5"></md-layout> -->
                <md-layout md-flex="50">
                  <md-input-container>
                    <label>Supplementary Invoice</label>
                    <md-file
:disabled="accounts == true && role!='Admin'?true:false"
                      name="invoiceUpload"
                      id="invoiceUpload"
                      v-model="SBDetail.slineInvoice"
                      @selected="onFileChangeBlDraft('Sline_Invoice')"
                      multiple
                    ></md-file>
                  </md-input-container>
                </md-layout>
              </md-layout>
              <md-layout md-gutter class="gutr">
                <!-- <div v-if="viewBLDraftDoc.length > 0">
                  <md-layout
                    md-flex="20"
                    v-for="(item, index) in viewBLDraftDoc"
                    :key="index"
                  >
                    <a
v-if="ffExportDetail.ffExportFclSeries"
                      :href="
                        `${docURL}/ASSIGNMENT_UPLOADS/` + ffExportDetail.ffExportFclSeries.replaceAll('/', '_') + '/' +
                        item
                      "
                      target="_blank"
                      download
                      >--View Document - {{ index + 1 }}</a
                    >
<br>
                  <a
                      :href="
                        `${docURL}/FF_Sea_Export_Sline_Payments_Uploads/` +
                        item
                      "
                      target="_blank"
                      download
                      >--View Document - {{ index + 1 }}</a
                    >
                  </md-layout>
                </div> -->
             

                <div v-if="viewInvDoc.length > 0">
                  <md-layout
                    md-flex="20"
                    v-for="(item, index) in viewInvDoc"
                    :key="index"
                  >
                    <a
                      v-if="ffExportDetail.ffExportFclSeries"
                      href="javascript:void(0)"
                      @click="openSignedDocument(`ASSIGNMENT_UPLOADS/${ffExportDetail.ffExportFclSeries.replaceAll('/', '_')}/${item}`)"
                      >--View Document - {{ index + 1 }}</a><br>
  <a
                      :href="
                        `${docURL}/FF_Sea_Export_Sline_Payments_Uploads/` +
                        item
                      "
                      target="_blank"
                      download
                      >--View Document - {{ index + 1 }}</a
                    >
                  </md-layout>
                </div>
              </md-layout>
  <md-layout md-gutter class="gutr">

 <md-layout md-flex="35">
                    <md-layout md-flex="100">
                      <label>POD</label>
                      <b-form-input :formatter="capitalizeAll"
disabled
                        name="POD"
                        id="POD"
                        v-model="POD"
                      ></b-form-input>
                    </md-layout>
 </md-layout>
<md-layout md-flex="5"></md-layout>
 <md-layout md-flex="20">
                    <md-layout md-flex="100">
                      <label>B/L No.</label>
                      <b-form-input :formatter="capitalizeAll"
:disabled="accounts == true && role!='Admin'?true:false"
                        name="POD"
                        id="POD"
                        v-model="SBDetail.SlineBlNo"
                      ></b-form-input>
                    </md-layout>
 </md-layout>
  </md-layout>
  <md-layout md-gutter class="gutr">
 <md-layout md-flex="35">
                    <md-layout md-flex="100">
                      <label>Shipping Line </label>
                      <b-form-input :formatter="capitalizeAll"
disabled
                        name="POD"
                        id="POD"
                        v-model="ffExportDetail.shippingLine"
                      ></b-form-input>
                    </md-layout>
 </md-layout>
 <md-layout md-flex="5"></md-layout>
 <md-layout md-flex="20">
                    <md-layout md-flex="100">
                      <label>Shipping line Invoice Amount</label>
                      <b-form-input :formatter="capitalizeAll"
:disabled="accounts == true && role!='Admin'?true:false"
                        name="shippingBillNo"
                        id="shippingBillNo"
                        v-model="SBDetail.invoiceAmount"
                        type="number"
                      ></b-form-input>
                    </md-layout>
 </md-layout>
   <md-layout md-flex="5"></md-layout>
   <md-layout md-flex="15">
                    <label>Estimated SOB Date </label>
                    <date-picker
@input="getDueDate"
:disabled="accounts == true && role!='Admin'?true:false"
                      lang="en"
                      :format="selectDateFormat"
                      name="sobDate"
                      id="sobDate"
                      v-model="SBDetail.sobDate"
                      :minute-step="1"
                    ></date-picker>
                    <!-- <span class="error" v-if="!SBDetail.payDate">{{errorSBExecution.payDate}}</span> -->
                  </md-layout>




 <md-layout md-flex="5"></md-layout>
 <md-layout md-flex="15">

                    <label>Payment Due Date</label>
                    <date-picker

disabled
                      lang="en"
                      :format="selectDateFormat"
                      name="sobDate"
                      id="sobDate"
                      v-model="SBDetail.dueDate"
                      :minute-step="1"
                    ></date-picker>
                    <!-- <span class="error" v-if="!SBDetail.payDate">{{errorSBExecution.payDate}}</span> -->
                  </md-layout>
                </md-layout>

<hr>
              <div
                v-if="
                  accounts == true ||
                  (SBDetail.paymentMode != '' && SBDetail.payRefNumber != '')
                "
              >
                <md-layout md-gutter class="mt-3">
                  <md-layout md-flex="95">
                    <h5>
                      <b-badge>Payment Details</b-badge>
                    </h5>
                  </md-layout>
                </md-layout>
                <md-layout md-gutter>
                  <md-layout md-flex="40">
                    <label for="custmClearByPridel">Payment Mode</label>

                    <model-list-select
                      :list="payList"
                      v-model="SBDetail.paymentMode"
                      option-value="payVal"
                      option-text="payText"
                      placeholder="Select Mode"
                    ></model-list-select>
                  </md-layout>
                </md-layout>
                <md-layout md-gutter class="gutr">
                  <md-layout md-flex="10">
                    <md-layout md-flex="100">
                      <label>Amount</label>
                      <b-form-input :formatter="capitalizeAll"
                        name="shippingBillNo"
                        id="shippingBillNo"
                        v-model="SBDetail.totalAmount"
                      ></b-form-input>
                    </md-layout>
                    <!-- <span
                          class="error"
                          v-if="!SBDetail.totalAmount"
                        >{{errorSBExecution.totalAmount}}</span>-->
                  </md-layout>

                  <md-layout
                    md-flex="5"
                    v-if="SBDetail.paymentMode != ''"
                  ></md-layout>
                  <md-layout md-flex="25" v-if="SBDetail.paymentMode != ''">
                    <md-layout md-flex="100">
                      <label
                        >{{
                          SBDetail.paymentMode == "1" ? "UTR" : "Cheque"
                        }}
                        Number</label
                      >
                      <b-form-input :formatter="capitalizeAll"
                        name="cargoGrossWeight"
                        id="cargoGrossWeight"
                        v-model="SBDetail.payRefNumber"
                      ></b-form-input>
                    </md-layout>
                    <!-- <span
                          class="error"
                          v-if="!SBDetail.cargoGrossWeight"
                        >{{errorSBExecution.cargoGrossWeight}}</span>-->
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="15">
                    <label>Payment Date</label>
                    <date-picker
                    :format="selectDateFormat"
                      lang="en"
                      name="shippingBillDate"
                      id="shippingBillDate"
                      v-model="SBDetail.payDate"
                      :minute-step="1"
                    ></date-picker>
                    <!-- <span class="error" v-if="!SBDetail.payDate">{{errorSBExecution.payDate}}</span> -->
                  </md-layout>
                </md-layout>
              </div>
              <md-layout md-gutter class="gutr">
                <md-layout md-flex="25">
                  <b-button
                    class="mt-3"
                    :disabled="SBDetail.paymentDone == '1' || disableSave==true || addSBDetail_button==true || disableSaveSup==true ? true : false"
                    variant="primary"
                    id="addButtonLoaderSB"
                    @click="addSBDetail"
                    >Save & Submit  </b-button
                  >
                  <md-spinner
                    md-indeterminate
                    id="loaderSB"
                    style="display: none"
                  ></md-spinner>
                </md-layout>
              </md-layout>
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      ref="popMailAfter"
    ></md-dialog-confirm>

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-confirm>
  </div>
</template>
<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect } from "vue-search-select";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../helper/filters";
import {
  globalPermissionStatus,
  GlobalGetLocation,
  GlobalContainerValid,
} from "../../helper/collection";

export default {
  beforeMount() {

    // if (
    //   (globalPermissionStatus("Sea Freight") ||
    //     globalPermissionStatus("Accounts")) &&
    //   this.$sessionsStorage.get("editffFclConsoExportId") != undefined &&
    //   this.$sessionsStorage.get("editffFclConsoExportId") != ""
    // ) 

    if (
      (globalPermissionStatus("Sea Freight") ||
        globalPermissionStatus("Accounts")) &&
      this.$sessionsStorage.get("editffFclConsoExportId") != undefined &&
      this.$sessionsStorage.get("editffFclConsoExportId") != ""
    ) {
      this.$store.dispatch(
        "setCurrentRoute",
        "/freightForward/ffConSLinePaymentExport_VP"
      );
// if(suplimentaryInvDataSingleArry && suplimentaryInvDataSingleArry.length>0){
//this.supffSlinePayDataArry=suplimentaryInvDataSingleArry;
// //alert()

// }
      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  watch: {
    ContainerTypeSizefactory: {
      handler(newVal, oldVal) {
        if (newVal.hasOwnProperty("containerNo")) {
          this.ContainerTypeSizefactory.containerNo = newVal.containerNo.toUpperCase();

          if (this.ContainerTypeSizefactory.packageId != "") {
            let arrayNew = this.packageNameList.filter((x) => {
              return x.packageId == this.ContainerTypeSizefactory.packageId;
            });

            if (arrayNew.length > 0) {
              this.ContainerTypeSizefactory.packageName =
                arrayNew[0].packageName;
            }
          }
        }
      },
      deep: true,
    },
//  SBDetail: {
//       handler(newVal, oldVal) {
//        if(this.SBDetail.sobDate){
// var date = new Date(this.SBDetail.sobDate);
// console.log(date)
// if(this.ffExportDetail.shippingId=='15'){
//  this.SBDetail.dueDate=date.setDate(date.getDate() + 9);
//  this.SBDetail.dueDate=new Date(this.SBDetail.dueDate)
// }else if(this.ffExportDetail.shippingId=='8'){

//  this.SBDetail.dueDate=date.setDate(date.getDate() + 9);
// this.SBDetail.dueDate=new Date(this.SBDetail.dueDate)
// }else if(this.ffExportDetail.shippingId=='13'){

//   this.SBDetail.dueDate=date.setDate(date.getDate() + 9);
// this.SBDetail.dueDate=new Date(this.SBDetail.dueDate)
// }else if(this.ffExportDetail.shippingId=='27'){
//  this.SBDetail.dueDate=date.setDate(date.getDate() + 13);
// this.SBDetail.dueDate=new Date(this.SBDetail.dueDate)

// }else{
//  this.SBDetail.dueDate=date.setDate(date.getDate() + 6) ;
// this.SBDetail.dueDate=new Date(this.SBDetail.dueDate)
// }

// }
//       },
//       deep: true,
//     },
  },
  props: ['suplimentaryInvDataSingleArry'],
  data() {
    return {
      selectDateFormat,
      accounts: globalPermissionStatus("Accounts"),
      payList: [
        {
          payVal: "1",
          payText: "RTGS",
        },
        {
          payVal: "2",
          payText: "Cheque",
        },
      ],
      showAlgo: false,
      algoConNo: "",
      docURL: URL_BASE_DOC,
      isLoading: false,
      value12: "",
      CCdone: "",
      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },
      unitList: [
        {
          uT: "KGS",
          uV: "KGS",
        },
        {
          uT: "MT",
          uV: "MT",
        },
      ],

      CCList: [
        {
          ccInfoVal: "Yes",
          ccInfoText: "Yes",
        },
        {
          ccInfoVal: "No",
          ccInfoText: "No",
        },
      ],
      getContainerList: [],
      getLocationList: [],
      ffExportDetail: {
POD:"",
allModuleId:"",
        clientName: "",
        ffExportFclSeries: "",
        portType: "",
        stuffingType: "",
        containerInfo: "",
        mergeffExportId: "",
        mergeSeries: "",
        shippingLine: "",
        FinalPlace: "",
        POR: "",
      },
POD:"",
      SBDetail: {
revisedMail:"0",
dueDate:"",
SlineBlNo:"",
invoiceAmount:"",
sobDate:"",
allModuleId:'',
        paymentDone: "",
        userId: "",
        stuffingType: "",
        blDraftUpload: "",
        slineInvoice: "",
        suplimentaryInvCount: "",
        supffSlinePayId: "",
        ffExportFclId: "",
        ffBookingId: "",
        ffExecutionId: "",
        doc2:"",
        paymentMode: "",
        totalAmount: "",
        payRefNumber: "",
        payDate: "",
        salesExeuctionNo: "",
        sline: "",
        clientName: "",
      },

      errorSBExecution: {
        shippingBillDate: "",
        shippingBillNo: "",

        cargoGrossWeight: "",
      },
      arraySBExecutionError: [
        "Enter Shippping Bill Date",
        "Enter Shipping Bill No",
        "Enter Cargo Weight",
      ],
      errorAtleastSb: "",
      errorAtleastContainer: "",

      WarehouseStuffing: {
        vgmSubmissionDate: "",
        gateInDate: "",
        siSubmissionDate: "",
        ffExecutionId: "",
        ffExportFclId: this.$sessionsStorage.get("editExportFCLId"),
        ffBookingId: this.$sessionsStorage.get("editFFBookingId"),

        stuffingType: "",
        portType: "",

        nameOfCFS: "",
        cartingDate: "",
        crnNumber: "",

        custmClearByPridel: "",
        ccAsignmentNo: "",
        containerInfo: "",
      },
      permissionStatus: true,
      sbDetailArray: [],
      supffSlinePayDataArry: [],
      showMoreSB: false,

      errorExecution: {
        cartingDate: "",
        crnNumber: "",
      },
      nameOfCFSError: "",
      arrayExecutionError: ["Select Carting Date", "Enter CRN Number"],

      ContainerTypeSizefactory: {
        netWeight: "",
        weightUnit: "",
        ffExecutionContainerId: "",
        containerTypeId: "",
        containerType: "",
        containerNo: "",
        cargoWeight: "",
        tareWeight: "",
        grossWeight: "",
        customSealNo: "",
        LineSealNo: "",
        cargoStuffingDate: "",
        leeoDate: "",
        leeoNo: "",
        handoverDate: "",
        measurement: "",
        packageId: "",
        packageName: "",
        noOfpkgUnit: "",
      },

      removeContainerVmodel: {
        ffExecutionContainerId: "",
        containerTypeId: "",
        containerType: "",
        containerNo: "",
        cargoWeight: "",
        tareWeight: "",
        grossWeight: "",
        customSealNo: "",
        LineSealNo: "",
        measurement: "",
        packageId: "",
        packageName: "",
        noOfpkgUnit: "",
      },
role:this.$sessionsStorage.get("designation"),
      packageNameList: [],
      nextPageType: "",

      errorContainer: {
        containerTypeId: "",
        containerNo: "",
        grossWeight: "",
        //    measurement: "",
        packageId: "",
        noOfpkgUnit: "",
      },
      arrayContainerError: [
        "Select Container Type",
        "Enter Container No.",
        "Enter Container Gross Weight1",
        // "Enter measurement",
        "Select Package",
        "Enter No of Packages",
      ],
      ContainerFromTPT: [],
      ContainerNoTPT: [],
      ContainerNoTypeTPT: [],
      editIndex: "",
      deleteId: "",
      showDivCountNote: false,
      BookingShippingLine: {
        assignmentNumber: "",
        bookingNumber: "",
        uploadBooking: "",
        validityBookingDate: "",
        bookingDate: "",
        vesselName: "",
        SICutOff: "",
        gateOpenDate: "",
        gateOpenTime: "",
        gateCloseDate: "",
        gateCloseTime: "",
        portCutDate: "",
        portCutTime: "",
        ENSCutDate: "",
        ENSCutTime: "",
        bookingShipment: "",
        stuffingType: "",
        vesselEta: "",
        vesselEtd: "",
        vgmCutOffDate: "",
        documentCutOffDate: "",
        voyageNo: "",
      },
      validateTrans: true,
      disableSaveSup: false,
      addSBDetail_button:false,
      validateSB: true,
      containerTypeDetailFactory: [],
      containerNoRegexError: "",
    };
  },

  mounted() {},

  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
  },
  computed: {
 disableSave() {
      return this.accounts == false && this.role!='Admin' && (!this.SBDetail.SlineBlNo ||  !this.SBDetail.invoiceAmount || !this.SBDetail.sobDate  || !this.SBDetail.slineInvoice)
        ? true
        : false;
    },
    viewBLDraftDoc() {
      return this.SBDetail.blDraftUpload != ""
        ? this.SBDetail.blDraftUpload.split(",")
        : [];
    },
    viewInvDoc() {
      return this.SBDetail.slineInvoice != ""
        ? this.SBDetail.slineInvoice.split(",")
        : [];
    },

    viewSlineInvDoc() {
      return this.SBDetail.slineInvoice != ""
        ? this.SBDetail.slineInvoice.split(",")
        : [];
    },
    sbDetailArrayList() {
      return this.sbDetailArray;
    },
    containerTypeDetailFactoryList() {
      return this.containerTypeDetailFactory;
    },
    ContainerTypeList() {
      return this.getContainerList;
    },
    masterList() {
      return this.getLocationList;
    },
  },
  methods: {
getDueDate(){
var date = new Date(this.SBDetail.sobDate);
console.log(date)
if(this.ffExportDetail.shippingId=='15'){
 this.SBDetail.dueDate=date.setDate(date.getDate() + 9);
 this.SBDetail.dueDate=new Date(this.SBDetail.dueDate)
}else if(this.ffExportDetail.shippingId=='8'){

 this.SBDetail.dueDate=date.setDate(date.getDate() + 9);
this.SBDetail.dueDate=new Date(this.SBDetail.dueDate)
}else if(this.ffExportDetail.shippingId=='13'){

  this.SBDetail.dueDate=date.setDate(date.getDate() + 9);
this.SBDetail.dueDate=new Date(this.SBDetail.dueDate)
}else if(this.ffExportDetail.shippingId=='27'){
 this.SBDetail.dueDate=date.setDate(date.getDate() + 13);
this.SBDetail.dueDate=new Date(this.SBDetail.dueDate)

}else{
 this.SBDetail.dueDate=date.setDate(date.getDate() + 6) ;
this.SBDetail.dueDate=new Date(this.SBDetail.dueDate)
}

},
    onFileChangeBlDraft(ID) {
      this.isLoading=true;
      let files = event.target.files || event.dataTransfer.files;
      let exportfclId = this.$sessionsStorage.get("editffFclConsoExportId");
      let formData = new FormData();
      for (let i = 0; i < files.length; i++) {
        formData.append("file[]", files[i]);

        if (ID == "Sline_Invoice") {
          formData.append(
            "staticFileName",
            "suplimentrySlineInvoive_" + exportfclId
          );
        } else if (ID == "BL_DRAFT") {
          formData.append(
            "staticFileName",
            "suplimentrySlineBLDraft_" + exportfclId
          );
        }

        formData.append(
          "upload_dir_folderName",
         // "FF_Sea_Export_Sline_Payments_Uploads"
       this.ffExportDetail.ffExportFclSeries.replaceAll("/", "_")
        );
      }

      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Accept: ID + exportfclId,
        },
      };

      axios
        .post(`${URL_BASE}/uploadFileCommonForAllTest.php`, formData, config)
        .then((result) => {
          if (ID == "BL_DRAFT") {
            this.SBDetail.blDraftUpload = result.data;
          } else {
            this.SBDetail.slineInvoice = result.data;
          }
     this.isLoading=false;
        })
        .catch((err) => {
          throw err;
        });
    },

    getConAlgoList() {
      //let self = this;

      if (this.ContainerTypeSizefactory.containerNo != "") {
        this.validContainerNo = GlobalContainerValid(
          this.ContainerTypeSizefactory.containerNo
        );
      }
    },

    doLoading() {
      this.isLoading = true;
    },
    doLoadingClose() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    previousSalesView() {
      window.history.go(-1);
      // if (this.ffExportDetail.containerInfo == "lcl") {
      //   this.$router.push({
      //     path: "/freightForward/ffExportFcl"
      //   });
      // } else {
      //   this.$router.push({
      //     path: "/freightForward/ffBooking"
      //   });
      // }
    },

    validateSBDetail() {
      let validate_new = true;
      Object.keys(this.errorSBExecution).map((x, index) => {
        if (this.SBDetail[x] == "") {
          this.errorSBExecution[x] = this.arraySBExecutionError[index];
          validate_new = false;
        }
      });

      if (validate_new == false) {
        this.validateSB = false;
      } else {
        this.validateSB = true;
      }
    },
    showMoreSBDet() {
      if (this.showMoreSB == false) {
        this.ContainerTypeSizefactory.ffExecutionContainerId == "";
        this.showMoreSB = true;
      } else {
        this.showMoreSB = false;
      }
    },
    viewEdit(id, index) {
      let array = this.containerTypeDetailFactory.filter((x) => {
        return x.ffExecutionContainerId == id;
      });

      Object.keys(this.ContainerTypeSizefactory).map((x) => {
        this.ContainerTypeSizefactory[x] = array[0][x];
      });
      this.showMoreSB = false;
    },

    addSBDetail() {
this.isLoading=true;
this.disableSaveSup=true;


this.SBDetail['ffExportFclSeries']=this.ffExportDetail.ffExportFclConsoSeries.replaceAll('/', '_');

if(!this.SBDetail.slineInvoice  && this.SBDetail.supffSlinePayId==''){
   this.alert.content = "Please Upload  Supplementary Invoice ";
                this.$refs["addPop"].open();
return false
}
this.SBDetail["uploadArray"] = [];
      if (this.SBDetail.slineInvoice) {
        let obj = {
          allModuleId:  this.ffExportDetail.allModuleId,
          docName: "suplimentrySlineInvoive_-" +  this.$sessionsStorage.get("editffFclConsoExportId") ,
          docLink: this.SBDetail.slineInvoice,
          doc2: this.SBDetail.doc2
        };
        this.SBDetail.uploadArray.push(obj);
      }
      if (this.SBDetail.blDraftUpload) {
        let obj1 = {
          allModuleId:  this.ffExportDetail.allModuleId,
          docName: "suplimentrySlineBLDraft_-" +  this.$sessionsStorage.get("editffFclConsoExportId"),
          docLink: this.SBDetail.blDraftUpload,
          doc2: this.SBDetail.doc2
        };
        this.SBDetail.uploadArray.push(obj1);
      }

      this.SBDetail["stuffingType"] = this.WarehouseStuffing.stuffingType;
      this.SBDetail["ffExportFclId"] = this.$sessionsStorage.get(
        "editExportFCLId"
      );
      this.SBDetail["ffBookingId"] = this.$sessionsStorage.get(
        "editFFBookingId"
      );
      this.SBDetail["ffFclConsoExportId"] = this.$sessionsStorage.get(
        "editffFclConsoExportId"
      );
      this.SBDetail["conFclBookingId"] = this.$sessionsStorage.get(
        "editconFclBookingId"
      );
      this.SBDetail["ffExecutionId"] ='0' ;
      // this.SBDetail["ffExecutionId"] ='0' ;
      // this.SBDetail["ffConExecutionId"] ='0' ;
      this.SBDetail["ffConExecutionId"] ='0' ;
      this.SBDetail.clientName = this.ffExportDetail.clientName;
      this.SBDetail.sline = this.ffExportDetail.shippingLine;
      this.SBDetail.POD = this.ffExportDetail.POD;
      this.SBDetail.salesExeuctionNo = this.ffExportDetail.ffExportFclConsoSeries;
console.log(this.SBDetail)
//return false
      // this.validateSBDetail();
      if (this.validateSB != false) {
        this.addSBDetail_button = true;
        // $("#addButtonLoaderSB").css("display", "none");
        // $("#loaderSB").css("display", "block");

        let options = {
          method: "POST",
           url: `${URL_BASE}/Api_SlineBillingCCExport/suplimentFFConExportSlinePayAdd.php`,
          // url: `${URL_BASE}/Api_SlineBillingSeaExport/suplimentSeaExportSlinePayAdd.php`,
          data: JSON.stringify(this.SBDetail),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if ( status == 200 && data) {

              // $("#loaderSB").css("display", "none");
              // $("#addButtonLoaderSB").css("display", "block");
             // window.history.go(-1);

              this.addSBDetail_button = false;
              if (data.msg == "Inserted Successfully") {
                this.alert.content = "Data Added Successfully";
              } else {
                this.alert.content = "Data Updated Successfully";
                this.$refs["addPop"].open();
              }
            }
this.isLoading=false;
          })
          .catch((error) => {});
      }
    },

    containerNoRegexfun() {
      this.showAlgo = true;
      this.getConAlgoList();
      this.algoConNo = this.validContainerNo;
      // let lastDigitReturn = this.validContainerNo.slice(
      //   this.validContainerNo.length - 7
      // );
      // let lastDigitCon = this.ContainerTypeSizefactory.containerNo.slice(
      //   this.ContainerTypeSizefactory.containerNo.length - 7
      // );
      let containerformat = new RegExp("^[a-zA-Z]{4}[0-9]{7}$");
      let arrayLen = [];
      if (this.ContainerTypeSizefactory.ffExecutionContainerId == "") {
        arrayLen = this.containerTypeDetailFactoryList.filter((x) => {
          return x.containerNo == this.ContainerTypeSizefactory.containerNo;
        });
      }

      if (
        arrayLen.length > 0 &&
        this.ContainerTypeSizefactory.ffExecutionContainerId == ""
      ) {
        this.containerNoRegexError = "Already Exist";
      } else if (
        containerformat.test(this.ContainerTypeSizefactory.containerNo)
      ) {
        this.containerNoRegexError = "";
      } else {
        this.containerNoRegexError = "Enter Valid Format";
      }
    },

    getData() {
// alert("Hello")


      this.doLoading();
this.disableSaveSup=false;
      if (this.sbDetailArrayList.length == 1) {
        this.sbDetailArray = [];
      }
      if (this.containerTypeDetailFactory.length == 1) {
        this.containerTypeDetailFactory = [];
      }
      if (this.getContainerList.length == 1) {
        this.getContainerList = [];
      }
      let new_data = {
        clientId: "clientId",
        ffFclConsoExportId: this.$sessionsStorage.get("editffFclConsoExportId"),
        ffConExecutionId: this.$sessionsStorage.get("editffConExecutionId"),
        conFclBookingId:
          this.$sessionsStorage.get("editconFclBookingId") != "" &&
          this.$sessionsStorage.get("editconFclBookingId") != undefined
            ? this.$sessionsStorage.get("editconFclBookingId")
            : "",
          allModuleId: this.$sessionsStorage.get("editSalesExId"),
      };
      let options = {
        method: "POST",
        // url: `${URL_BASE}/Api_FFSeaExport/viewFFBookingDetails_NewV3.php`,
        url: `${URL_BASE}/Api_FFSeaExport/viewFFConBookingDetails_NewV3.php`,
        data: JSON.stringify(new_data),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;

          if ( status == 200 && data) {
             console.log("this.data=>",data)
            if (data.ContainerFromTPT.length > 0) {
              if (!this.$sessionsStorage.get("editffConExecutionId")) {
                this.$sessionsStorage.set(
                  "editffConExecutionId",
                  data.autoExecutionId
                );
              }
              this.ContainerFromTPT = data.ContainerFromTPT;

              if (data.ContainerFromTPT[0].ContainerNumber != null) {
                this.ContainerNoTPT = data.ContainerFromTPT[0].ContainerNumber.split(
                  ","
                );
              }
              if (data.ContainerFromTPT[0].ContainerType.length > 0) {
                this.ContainerNoTypeTPT = data.ContainerFromTPT[0].ContainerType.split(
                  ","
                );
              }
              this.conDetailsTPT =
                data.ContainerFromTPT[0].ContainerType +
                "\n" +
                data.ContainerFromTPT[0].ContainerNumber;
            }

            this.getLocationList = data.portLocationArray;
            // console.log("this.getLocationList=>",this.getLocationList)
            if (data.containerCountWise.length > 0) {
              this.containerCountWise = data.containerCountWise;
              let array_new = this.containerCountWise.map((x) => {
                if (x.totalCount == 0) {
                  this.showDivCountNote = false;
                } else {
                  this.showDivCountNote = true;
                  return false;
                }
              });
            }

            if (data.packageNameList.length > 0) {
              this.packageNameList = data.packageNameList;
            }

            if (data.containerMaster.length > 0) {
              this.getContainerList = data.containerMaster;
            }

            if (data.ffBookingDetail.length > 0) {
              Object.keys(data.ffBookingDetail[0]).map((x) => {
                this.BookingShippingLine[x] = data.ffBookingDetail[0][x] || "";
              });
            }

            if (data.editFFEX.length > 0) {
              this.WarehouseStuffing.portType = data.editFFEX[0].portType;
              this.SBDetail.allModuleId = data.editFFEX[0].allModuleId;
              this.POD = data.editFFEX[0].POD;
        

              this.WarehouseStuffing.stuffingType =
                data.editFFEX[0].stuffingType;

              this.WarehouseStuffing.containerInfo =
                data.editFFEX[0].containerInfo;
              Object.keys(data.editFFEX[0]).map((x) => {
                this.ffExportDetail[x] = data.editFFEX[0][x] || "";
              });
     
            }

            if (data.ffBookingTranshipment.length > 0) {
              this.tentativeDetailArray = data.ffBookingTranshipment;
            }

            if (
              this.$sessionsStorage.get("editFFExecutionId") != "" &&
              this.$sessionsStorage.get("editFFExecutionId") != undefined
            ) {
              this.viewExecutionDetail();
            } else {
              this.doLoadingClose();
            }
            // this.JqueryFun();
          }
        })
        .catch((error) => {});
    },
    viewExecutionDetail() {


console.log(this.suplimentaryInvDataSingleArry,"uiyiu")
      this.doLoading();
      let new_data = {
        clientId: "clientId",
       ffFclConsoExportId: this.$sessionsStorage.get("editffFclConsoExportId"),
        ffConExecutionId: this.$sessionsStorage.get("editffConExecutionId"),
        conFclBookingId:
          this.$sessionsStorage.get("editconFclBookingId") != "" &&
          this.$sessionsStorage.get("editconFclBookingId") != undefined
            ? this.$sessionsStorage.get("editconFclBookingId")
            : "",
        newData: this.ffExportDetail,
      };
      
      let options = {
        method: "POST",
        // url: `${URL_BASE}/Api_FFSeaExport/viewExecutionDetail.php`,
         url: `${URL_BASE}/Api_FFSeaExport/viewConExecutionDetail.php`,
        data: JSON.stringify(new_data),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;

          if ( status == 200 && data) {
console.log(this.suplimentaryInvDataSingleArry,"tuytyrr");
             if (this.suplimentaryInvDataSingleArry.length > 0) {
              Object.keys(this.SBDetail).map((x) => {
                this.SBDetail[x] = this.suplimentaryInvDataSingleArry[0][x] || "";
              });
           }else{
 Object.keys(this.SBDetail).map((x) => {
                this.SBDetail[x] = "";
              });
  if (data.ffSLinePayDetail.length > 0) {
              Object.keys(this.SBDetail).map((x) => {
                this.SBDetail[x] = data.ffSLinePayDetail[0][x] || "";
              });

this.SBDetail.slineInvoice="";
this.SBDetail.blDraftUpload="";
this.SBDetail.invoiceAmount="";
this.SBDetail.paymentMode="";
this.SBDetail.paymentDone="";
this.SBDetail.payRefNumber="";
this.SBDetail.payDate="";
this.SBDetail.totalAmount="";
            }

}

console.log(this.SBDetail,"yioiu")
            if (data.ffExecutionDetail.length > 0) {
              Object.keys(this.WarehouseStuffing).map((x) => {
                this.WarehouseStuffing[x] = data.ffExecutionDetail[0][x] || "";
              });
            }

            if (data.ffExecutionDetailContainer.length > 0) {
              if (this.ContainerFromTPT.length > 0) {
                let dummyContainer = [];
                for (
                  let i = 0;
                  i < data.ffExecutionDetailContainer.length;
                  i++
                ) {
                  let obj = {
                    ffExecutionContainerId:
                      data.ffExecutionDetailContainer[i].ffExecutionContainerId,
                    containerTypeId:
                      data.ffExecutionDetailContainer[i].containerTypeId,
                    containerType:
                      data.ffExecutionDetailContainer[i].containerType,
                    LineSealNo: data.ffExecutionDetailContainer[i].LineSealNo,
                    PickupLocation:
                      data.ffExecutionDetailContainer[i].PickupLocation,
                    StuffingLocation:
                      data.ffExecutionDetailContainer[i].StuffingLocation,
                    cargoStuffingDate:
                      data.ffExecutionDetailContainer[i].cargoStuffingDate,
                    cargoWeight: data.ffExecutionDetailContainer[i].cargoWeight,
                    containerInfo:
                      data.ffExecutionDetailContainer[i].containerInfo,
                    containerWithSplit:
                      data.ffExecutionDetailContainer[i].containerWithSplit,
                    customSealNo:
                      data.ffExecutionDetailContainer[i].customSealNo,
                    ffExecutionId:
                      data.ffExecutionDetailContainer[i].ffExecutionId,
                    ffExportFclId:
                      data.ffExecutionDetailContainer[i].ffExportFclId,
                    grossWeight: data.ffExecutionDetailContainer[i].grossWeight,
                    handoverDate:
                      data.ffExecutionDetailContainer[i].handoverDate,
                    leeoDate: data.ffExecutionDetailContainer[i].leeoDate,
                    leeoNo: data.ffExecutionDetailContainer[i].leeoNo,
                    measurement: data.ffExecutionDetailContainer[i].measurement,
                    netWeight: data.ffExecutionDetailContainer[i].netWeight,
                    noOfpkgUnit: data.ffExecutionDetailContainer[i].noOfpkgUnit,
                    packageId: data.ffExecutionDetailContainer[i].packageId,
                    pickupDate: data.ffExecutionDetailContainer[i].pickupDate,
                    portType: data.ffExecutionDetailContainer[i].portType,
                    stuffingDate:
                      data.ffExecutionDetailContainer[i].stuffingDate,
                    tareWeight: data.ffExecutionDetailContainer[i].tareWeight,
                    weightUnit: data.ffExecutionDetailContainer[i].weightUnit,
                    containerNo:
                      data.ffExecutionDetailContainer[i].containerNo == ""
                        ? this.ContainerNoTPT[i]
                        : data.ffExecutionDetailContainer[i].containerNo,
                  };
                  dummyContainer.push(obj);
                }
                this.containerTypeDetailFactory = dummyContainer;
              } else {
                this.containerTypeDetailFactory =
                  data.ffExecutionDetailContainer;
              }

              Object.keys(this.ContainerTypeSizefactory).map((x) => {
                this.ContainerTypeSizefactory[x] =
                  data.ffExecutionDetailContainer[0][x] || "";
              });

              Object.keys(this.removeContainerVmodel).map((x) => {
                this.ContainerTypeSizefactory[x] = "";
              });
            }

            if (data.ffSBDetail.length > 0) {
              this.sbDetailArray = data.ffSBDetail;
            }
            this.doLoadingClose();
          }
        })
        .catch((error) => {});
    },
    // JqueryFun() {
    //   return $(function() {
    //     return $("#ffContainer").DataTable();
    //   });
    // }
  },
};
</script>
<style>
.md-direction-bottom-right {
  width: 18% !important;
}

.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// ffConSLineSuplimentryPayment_VP.vue?942f4ba2